import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { formatTimelessDateStr } from "../../../utils/dates";
import { assert } from "../../../utils/assert";
import { ProgramType, useLegacyApplication } from "./application";
import { useApplicationPageAggregatedData } from "./aggregatedData";
import sortBy from 'lodash/sortBy';
export var IntakeStatus = /*#__PURE__*/function (IntakeStatus) {
  IntakeStatus["OPEN"] = "open";
  IntakeStatus["OPEN_CONDITIONALLY"] = "open_conditionally";
  IntakeStatus["WILL_OPEN"] = "will_open";
  IntakeStatus["WILL_OPEN_CONDITIONALLY"] = "will_open_conditionally";
  IntakeStatus["CLOSED"] = "closed";
  IntakeStatus["CLOSED_CONDITIONALLY"] = "closed_conditionally";
  IntakeStatus["LIKELY_OPEN"] = "likely_open";
  IntakeStatus["WAITLIST"] = "waitlist";
  return IntakeStatus;
}({});
export function useIntakes() {
  var _useApplicationPageAg = useApplicationPageAggregatedData({
      select: function select(aggregatedData) {
        var _aggregatedData$inclu;
        return (_aggregatedData$inclu = aggregatedData.included.filter(function (item) {
          return item.type === 'intake';
        })) === null || _aggregatedData$inclu === void 0 ? void 0 : _aggregatedData$inclu.map(function (intakeInsight) {
          return intakeInsight.attributes;
        });
      }
    }),
    data = _useApplicationPageAg.data;
  var eslIntakes = data === null || data === void 0 ? void 0 : data.filter(function (intake) {
    return intake.programType === ProgramType.Esl;
  });
  var academicIntakes = data === null || data === void 0 ? void 0 : data.filter(function (intake) {
    return intake.programType === ProgramType.Main;
  });
  return {
    intakes: data || [],
    eslIntakes: eslIntakes || [],
    academicIntakes: academicIntakes || []
  };
}
export function useCurrentInsightScoreToDisplay() {
  var _useLegacyApplication = useLegacyApplication(),
    legacyApplication = _useLegacyApplication.legacyApplication;
  var _useIntakes = useIntakes(),
    intakes = _useIntakes.intakes;
  var program = legacyApplication === null || legacyApplication === void 0 ? void 0 : legacyApplication.programs.find(function (item) {
    return item.programType === ProgramType.Main;
  });
  return intakes === null || intakes === void 0 ? void 0 : intakes.find(function (score) {
    return score.programType === ProgramType.Main && score.startDate === (program === null || program === void 0 ? void 0 : program.intake.startDate);
  });
}
export var generateIntakeOptions = function generateIntakeOptions(_ref) {
  var selectedIntake = _ref.selectedIntake,
    intakes = _ref.intakes,
    useIds = _ref.useIds;
  return sortBy(intakes, 'startDate').map(function (intake) {
    return {
      label: "".concat(formatTimelessDateStr(intake.startDate, 'YYYY - MMMM')).concat(intake.startDate === selectedIntake ? ' (Current)' : ''),
      value: useIds ? intake.intakeId.toString() : intake.startDate
    };
  });
};
export function useApplicationMainIntake() {
  //TODO: Migrate this to use modern application once we can rely on intake IDs
  var _useLegacyApplication2 = useLegacyApplication(),
    legacyApplication = _useLegacyApplication2.legacyApplication;
  var _useIntakes2 = useIntakes(),
    intakes = _useIntakes2.intakes;
  var academicProgram = legacyApplication.programs.find(function (program) {
    return program.programType === ProgramType.Main;
  });
  assert(academicProgram, 'Legacy application missing academic program');
  var mainIntake = intakes.find(function (intake) {
    return intake.programType === ProgramType.Main && intake.startDate === academicProgram.intake.startDate;
  });
  return {
    mainIntake: mainIntake
  };
}
export function useApplicationEslIntake() {
  //TODO: Migrate this to use modern application once we can rely on intake IDs
  var _useLegacyApplication3 = useLegacyApplication(),
    legacyApplication = _useLegacyApplication3.legacyApplication;
  var _useIntakes3 = useIntakes(),
    intakes = _useIntakes3.intakes;
  var eslProgram = legacyApplication.programs.find(function (program) {
    return program.programType === ProgramType.Esl;
  });
  var eslIntake = intakes.find(function (intake) {
    return intake.programType === ProgramType.Esl && intake.startDate === (eslProgram === null || eslProgram === void 0 ? void 0 : eslProgram.intake.startDate);
  });
  return {
    eslIntake: eslIntake
  };
}